import type { KeyboardEvent } from 'react'

// Cmd+Enter on macOS, Ctrl+Enter everywhere else
export const isSubmitHotkey = (event: KeyboardEvent): boolean =>
  event.key === 'Enter' && (event.metaKey || event.ctrlKey)
